import React from "react";
import UnderConstruction from "../../../../common/UnderConstruction";

const BlogsSection = () => {
  return <UnderConstruction />;
};

export default BlogsSection;
